import { ElDatePicker } from "element-plus"
import { h } from "vue"
import moment from "moment"
import { useStore } from "vuex";

export default {
  name: "BaseDatePicker",
  props: {
    ...ElDatePicker.props,
    specialType: {
      type: String,
      default: "",
    },
  },
  setup(props, { attrs, slots }) {
    const store = useStore()
    const getOptions = (store) => ({
      disabledDate: (date) => {
        const from = moment().set({ year: store.getters["Contexts/getYear"] }).startOf("year")
        const till = moment().set({ year: store.getters["Contexts/getYear"] }).endOf("year")
        return !moment(date).isBetween(from, till, null, "[]")
      }
    })

    const getBzOptions = (store) => ({
      disabledDate: (date) => {
        const start = store.getters["Contexts/getContext"]("startDateOfGrainBalance")
        const end = store.getters["Contexts/getContext"]("endDateOfGrainBalance")
        return !moment(date).isBetween(start, end, null, "[]")
      }
    })

    return () => {
      const options = props.specialType === "grainbalance"
        ? getBzOptions(store)
        : getOptions(store)

      const defaultValue = props.specialType === "grainbalance"
        ? new Date(moment(store.getters["Contexts/getContext"]("startDateOfGrainBalance")).format("YYYY-MM-DD"))
        : new Date(moment().set({ year: store.getters["Contexts/getYear"] }).startOf("year").format("YYYY-MM-DD"))

      return h(ElDatePicker, {
        ...attrs,
        ...props,
        disabledDate: options.disabledDate,
        firstDayOfWeek: 1,
        defaultValue,
        'onUpdate:modelValue': value => attrs['onUpdate:modelValue']?.(value)
      }, slots.default?.())
    }
  }
}
